var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.katalogEnabled && _vm.isMobileNavigationOpen
        ? _c(
            "a",
            {
              staticClass: "mobile-katalog",
              attrs: { href: _vm.urlKatalogLink }
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.urlKatalogImg,
                  alt: "Katalog",
                  title: "Katalog"
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.blog.length > 0
        ? [
            _c(
              "div",
              {
                staticClass: "mobile-navigation",
                class: [
                  { open: _vm.isMobileNavigationOpen },
                  { blogMobileNav: _vm.blog.length > 0 }
                ]
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isNavigationInitialized,
                        expression: "isNavigationInitialized"
                      }
                    ]
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "mainmenu w-100 p-0 m-0 menu-active" },
                      [
                        _vm._l(_vm.blog, function(blogitem) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  "aria-label": blogitem.name,
                                  href: blogitem.nameUrl
                                }
                              },
                              [_vm._v(_vm._s(blogitem.name))]
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                color: "rgb(193, 34, 50)!important",
                                "font-size": "18px",
                                "font-weight": "600"
                              },
                              attrs: { href: "/", "aria-label": "bigtex Shop" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Bigtex5::Template.backToShop"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav-direction d-flex align-items-center mHeader"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Bigtex5::Template.headerMisc"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.urlContact,
                                "aria-label": "Kontakt"
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-envelope" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Bigtex5::Template.headerContactForm"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.urlNewsletter,
                                "aria-label": "newsletter"
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-envelope-o" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Bigtex5::Template.headerNewsletter"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.urlKatalog,
                                "aria-label": "Katalog"
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-bookmark" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Bigtex5::Template.headerKatalog"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.calcTelTime
                          ? _c(
                              "li",
                              {
                                staticClass: "ddown",
                                attrs: { "aria-label": "Telefon" }
                              },
                              [
                                _c("a", { attrs: { href: _vm.urlPhone } }, [
                                  _c("i", { staticClass: "fa fa-phone" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Bigtex5::Template.headerPhoneAssist"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.isNavigationInitialized
                  ? [
                      _c(
                        "ul",
                        { staticClass: "mainmenu w-100 p-0 m-0 menu-active" },
                        _vm._l(_vm.skeletonItemCount, function(index) {
                          return _c(
                            "li",
                            { key: "skeleton-" + index, staticClass: "ddown" },
                            [
                              _c("span", {
                                staticClass: "nav-placeholder m-3",
                                style: { width: _vm.getRandomWidth() + "%" }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : [
            _c(
              "div",
              {
                staticClass: "mobile-navigation",
                class: [{ open: _vm.isMobileNavigationOpen }]
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isNavigationInitialized,
                        expression: "isNavigationInitialized"
                      }
                    ]
                  },
                  [
                    _c(
                      "ul",
                      {
                        directives: [{ name: "menu", rawName: "v-menu" }],
                        staticClass: "mainmenu w-100 p-0 m-0 menu-active",
                        attrs: { id: "menu-1" }
                      },
                      [
                        _vm.dataContainer1.parent
                          ? _c(
                              "li",
                              {
                                staticClass: "ddown",
                                on: {
                                  click: function($event) {
                                    return _vm.slideTo(
                                      (_vm.dataContainer1.parent &&
                                        _vm.dataContainer1.parent.parent) ||
                                        null,
                                      true
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nav-direction d-flex align-items-center mHeader"
                                  },
                                  [
                                    _vm.selectedCat
                                      ? [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-long-arrow-left",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-fill text-center"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.selectedCat.details[0]
                                                      .name
                                                  ) +
                                                  "\n                            "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.dataContainer1.categories, function(
                          category
                        ) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.getCategoryUrl(category.url),
                                  "aria-label":
                                    "Link zu " + category.details[0].name
                                }
                              },
                              [_vm._v(_vm._s(category.details[0].name))]
                            ),
                            _vm._v(" "),
                            category.childCount
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "nav-direction",
                                    on: {
                                      click: function($event) {
                                        return _vm.slideTo(category)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-arrow-right",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        }),
                        _vm._v(" "),
                        _vm.dataContainer1.categories[0]
                          ? _vm._l(
                              _vm.dataContainer1.categories[0].siblingCount -
                                _vm.dataContainer1.categories.length,
                              function(number) {
                                return _c("li", { staticClass: "ddown" }, [
                                  _c("span", {
                                    staticClass: "nav-placeholder m-3",
                                    style: {
                                      width: Math.random() * 20 + 60 + "%"
                                    }
                                  })
                                ])
                              }
                            )
                          : _vm.dataContainer1.parent
                          ? _vm._l(
                              _vm.dataContainer1.parent.childCount,
                              function(number) {
                                return _c("li", { staticClass: "ddown" }, [
                                  _c("span", {
                                    staticClass: "nav-placeholder m-3",
                                    style: {
                                      width: Math.random() * 20 + 60 + "%"
                                    }
                                  })
                                ])
                              }
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href:
                                  "https://www.google.com/storepages?q=bigtex.de&c=DE&v=19&hl=de&so=NEWEST#reviews",
                                "aria-label": "Rezensionen bei Google"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-google mr-2 google-bg"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getRating()) +
                                  " / 5,0 Google Rezensionen\n            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.breadcrumbs.length == 0
                          ? [
                              _c("li", [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nav-direction d-flex align-items-center mHeader"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex-fill text-center" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Bigtex5::Template.headerMisc"
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "ddown" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.urlContact,
                                      "aria-label": "Kontakt"
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-envelope" }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Bigtex5::Template.headerContactForm"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "ddown" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.urlNewsletter,
                                      "aria-label": "Newsletter"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-envelope-o"
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Bigtex5::Template.headerNewsletter"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "ddown" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.urlKatalog,
                                      "aria-label": "Katalog"
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-bookmark" }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Bigtex5::Template.headerKatalog"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.calcTelTime
                                ? _c("li", { staticClass: "ddown" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.urlPhone,
                                          "aria-label": "Telefon"
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-phone" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Bigtex5::Template.headerPhoneAssist"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        directives: [{ name: "menu", rawName: "v-menu" }],
                        staticClass: "mainmenu w-100 p-0 m-0",
                        attrs: { id: "menu-2" }
                      },
                      [
                        _vm.dataContainer2.parent
                          ? _c(
                              "li",
                              {
                                staticClass: "ddown",
                                on: {
                                  click: function($event) {
                                    return _vm.slideTo(
                                      (_vm.dataContainer2.parent &&
                                        _vm.dataContainer2.parent.parent) ||
                                        null,
                                      true
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nav-direction d-flex align-items-center mHeader"
                                  },
                                  [
                                    _vm.selectedCat
                                      ? [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-long-arrow-left",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-fill text-center"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.selectedCat.details[0]
                                                      .name
                                                  ) +
                                                  "\n                            "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.dataContainer2.categories, function(
                          category
                        ) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  "aria-label":
                                    "Link zu " + category.details[0].name,
                                  href: _vm.getCategoryUrl(category.url)
                                }
                              },
                              [_vm._v(_vm._s(category.details[0].name))]
                            ),
                            _vm._v(" "),
                            category.childCount
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "nav-direction",
                                    on: {
                                      click: function($event) {
                                        return _vm.slideTo(category)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-arrow-right",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        }),
                        _vm._v(" "),
                        _vm.dataContainer2.categories[0]
                          ? _vm._l(
                              _vm.dataContainer2.categories[0].siblingCount -
                                _vm.dataContainer2.categories.length,
                              function(number) {
                                return _c("li", { staticClass: "ddown" }, [
                                  _c("span", {
                                    staticClass: "nav-placeholder m-3",
                                    style: {
                                      width: Math.random() * 20 + 60 + "%"
                                    }
                                  })
                                ])
                              }
                            )
                          : _vm.dataContainer2.parent
                          ? _vm._l(
                              _vm.dataContainer2.parent.childCount,
                              function(number) {
                                return _c("li", { staticClass: "ddown" }, [
                                  _c("span", {
                                    staticClass: "nav-placeholder m-3",
                                    style: {
                                      width: Math.random() * 20 + 60 + "%"
                                    }
                                  })
                                ])
                              }
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.breadcrumbs.length == 0
                          ? [
                              _c("li", [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nav-direction d-flex align-items-center mHeader"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex-fill text-center" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Bigtex5::Template.headerMisc"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "ddown" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      "aria-label": "Kontakt",
                                      href: _vm.urlContact
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Bigtex5::Template.headerContactForm"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "ddown" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.urlNewsletter,
                                      "aria-label": "Newsletter"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Bigtex5::Template.headerNewsletter"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "ddown" }, [
                                _c("a", { attrs: { href: _vm.urlKatalog } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Bigtex5::Template.headerKatalog"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.calcTelTime
                                ? _c("li", { staticClass: "ddown" }, [
                                    _c("a", { attrs: { href: _vm.urlPhone } }, [
                                      _c("i", { staticClass: "fa fa-phone" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Bigtex5::Template.headerPhoneAssist"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.isNavigationInitialized
                  ? [
                      _c(
                        "ul",
                        { staticClass: "mainmenu w-100 p-0 m-0 menu-active" },
                        _vm._l(_vm.skeletonItemCount, function(index) {
                          return _c(
                            "li",
                            { key: "skeleton-" + index, staticClass: "ddown" },
                            [
                              _c("span", {
                                staticClass: "nav-placeholder m-3",
                                style: { width: _vm.getRandomWidth() + "%" }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "ddown" }, [
      _c("a", { attrs: { href: "/magazin/", "aria-label": "Blog" } }, [
        _vm._v("\n              Magazin\n            ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }